import React, {Component} from 'react'
import { browserHistory } from 'react-router'
import {Link} from 'react-router'

import * as firebase from 'firebase'

const Jeyu = {
  banner: {
    background: '#333',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  listBox: {
    padding: 25,
    boxShadow: '0 0 4px rgba(255,255,255,.5)',
    cursor: 'pointer',
    color: '#fff'
  }
}

export default class Dashboard extends Component {

  componentDidMount() {
    var user = firebase.auth().currentUser
     if (user) {
       console.log('歡迎Admin')
     } else {
       browserHistory.push('/')
     }
    event.preventDefault()
  }
  render() {
    return(
      <div className="container-fluid">
         <div style={Jeyu.banner}>
          <div style={Jeyu.list}>
           <Link to="/" style={Jeyu.listBox}>修改首頁Banner</Link>
           <Link to="/add" style={Jeyu.listBox}>新增Blog</Link>
          </div>
         </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Dashboard.js